enum DashboardRange {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  // "Global": all-time figures.
  ALL = 'ALL',
}

interface DashboardDay {
  // YYYY-MM-DD in Europe/Paris
  date: string;
  installs: number;
  signups: number;
}

interface DashboardEngagementDay {
  // YYYY-MM-DD in Europe/Paris
  date: string;
  views: number;
  likes: number;
}

// Rates are between 0 and 1, null when there is nothing to divide by.
interface AdminDashboard {
  acquisition: {
    // First seen in the period, all platforms.
    installs: number;
    signups: number;
    conversionRate: number | null;
    daily: DashboardDay[];
  };
  activity: {
    // null for ALL: no meaning all time.
    connectedUsers: number | null;
    // Share (0 to 1) of the connected players already connected in the previous period, null for ALL.
    returningRate: number | null;
    videosPosted: number;
  };
  // What the connected players did in the period (a visitor's views are not dated).
  engagement: {
    views: number;
    likes: number;
    comments: number;
    favorites: number;
    shares: number;
    follows: number;
    daily: DashboardEngagementDay[];
  };
  moderation: {
    // Created in the period.
    reports: number;
    // Still to handle, whatever the period.
    openReports: number;
  };
  // The previous period of the same length (today: yesterday until the same time), null all time.
  previous: {
    installs: number;
    signups: number;
    conversionRate: number | null;
    connectedUsers: number | null;
    videosPosted: number;
    views: number;
    likes: number;
    comments: number;
    favorites: number;
    shares: number;
    follows: number;
  } | null;
}

export { DashboardRange };
export type { AdminDashboard, DashboardDay, DashboardEngagementDay };
